import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowLeft, Mail } from 'lucide-react';
export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email) {
      setError('Please enter your email address.');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setIsSubmitted(true);
  };
  return <div className="min-h-screen bg-aliceBlue flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8" data-id="element-426">
      <div className="sm:mx-auto sm:w-full sm:max-w-md text-center" data-id="element-427">
        <Link to="/" data-id="element-428">
          <img src="https://cdn.magicpatterns.com/uploads/u4AKTM42BTBGHrLv1PiYxT/Logo_3.png" alt="LawVo" className="h-10 object-contain mx-auto mb-8" data-id="element-429" />
        </Link>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-430">
        <div className="bg-white py-8 px-6 shadow-sm sm:rounded-xl sm:px-10 border border-borderColor" data-id="element-431">
          {isSubmitted ? <div className="text-center py-4" data-id="element-432">
              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-aliceBlue mb-6" data-id="element-433">
                <Mail className="h-8 w-8 text-violetBlue" data-id="element-434" />
              </div>
              <h3 className="text-2xl font-bold text-primary mb-3" data-id="element-435">
                Check your email
              </h3>
              <p className="text-secondary mb-8" data-id="element-436">
                We've sent a password reset link to{' '}
                <span className="font-semibold text-primary" data-id="element-437">{email}</span>. It
                may take a minute to arrive.
              </p>
              <div className="space-y-3" data-id="element-438">
                <Link to="/login" className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-semibold text-white bg-violetBlue hover:opacity-90 transition-opacity" data-id="element-439">
                  Return to Log In
                </Link>
                <button onClick={() => setIsSubmitted(false)} className="w-full flex justify-center py-3 px-4 border border-borderColor rounded-lg text-sm font-semibold text-primary bg-white hover:bg-aliceBlue transition-colors" data-id="element-440">
                  Try a different email
                </button>
              </div>
            </div> : <>
              <div className="text-center mb-6" data-id="element-441">
                <h2 className="text-2xl font-bold text-primary mb-2" data-id="element-442">
                  Reset your password
                </h2>
                <p className="text-secondary text-sm" data-id="element-443">
                  Enter the email address associated with your account and we'll
                  send you a link to reset your password.
                </p>
              </div>

              <form className="space-y-5" onSubmit={handleSubmit} noValidate data-id="element-444">
                {error && <div className="p-3 rounded-lg bg-destructive/10 border border-destructive/20" data-id="element-445">
                    <p className="text-sm text-destructive font-medium" data-id="element-446">
                      {error}
                    </p>
                  </div>}

                <div data-id="element-447">
                  <label className="block text-sm font-medium text-primary mb-1" data-id="element-448">
                    Email address
                  </label>
                  <input type="email" required value={email} onChange={e => {
                setEmail(e.target.value);
                setError('');
              }} className={`w-full px-4 py-3 rounded-lg border ${error ? 'border-destructive' : 'border-borderColor'} focus:ring-2 focus:ring-violetBlue focus:border-violetBlue outline-none transition-all`} placeholder="you@example.com" data-id="element-449" />
                </div>

                <button type="submit" className="w-full flex justify-center py-3.5 px-4 border border-transparent rounded-lg shadow-sm text-sm font-semibold text-white bg-violetBlue hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violetBlue transition-opacity" data-id="element-450">
                  Send Reset Link
                </button>
              </form>
            </>}
        </div>

        <p className="mt-6 text-center" data-id="element-451">
          <Link to="/login" className="inline-flex items-center text-sm font-semibold text-secondary hover:text-primary transition-colors" data-id="element-452">
            <ArrowLeft className="w-4 h-4 mr-1" data-id="element-453" /> Back to log in
          </Link>
        </p>
      </motion.div>
    </div>;
}